export interface ContextualMenuUi {
  showEdit: boolean;
  showView: boolean;
  showDeleteDialog: boolean;
  showDuplicateDialog: boolean;
  open: boolean;
}
export const initialState: ContextualMenuUi = {
  showDeleteDialog: false,
  showDuplicateDialog: false,
  showEdit: false,
  showView: false,
  open: false,
};
